import type { CrmMessages } from "./englishCrmMessages";

export const germanCrmMessages = {
  resources: {
    companies: {
      name: "Organisation |||| Organisationen",
      forcedCaseName: "Organisation",
      fields: {
        name: "Unternehmensname",
        website: "Webseite",
        linkedin_url: "LinkedIn-URL",
        phone_number: "Telefonnummer",
        created_at: "Erstellt am",
        nb_contacts: "Anzahl Kontakte",
        revenue: "Umsatz",
        sector: "Branche",
        size: "Größe",
        tax_identifier: "Steuernummer",
        address: "Adresse",
        city: "Stadt",
        zipcode: "PLZ",
        state_abbr: "Bundesland",
        country: "Land",
        description: "Beschreibung",
        context_links: "Kontext-Links",
        sales_id: "Zuständig",
      },
      empty: {
        description: "Ihre Unternehmensliste ist leer.",
        title: "Keine Unternehmen gefunden",
      },
      import: {
        title: "Firmen importieren",
      },
      field_categories: {
        contact: "Kontakt",
        additional_info: "Zusätzliche Informationen",
        address: "Adresse",
        context: "Kontext",
      },
      action: {
        create: "Unternehmen anlegen",
        edit: "Unternehmen bearbeiten",
        new: "Neues Unternehmen",
        show: "Unternehmen anzeigen",
      },
      added_on: "Hinzugefügt am %{date}",
      followed_by: "Betreut von %{name}",
      followed_by_you: "Von Ihnen betreut",
      no_contacts: "Kein Kontakt",
      nb_contacts: "%{smart_count} Kontakt |||| %{smart_count} Kontakte",
      nb_deals: "%{smart_count} Deal |||| %{smart_count} Deals",
      sizes: {
        one_employee: "1 Mitarbeiter",
        two_to_nine_employees: "2–9 Mitarbeiter",
        ten_to_forty_nine_employees: "10–49 Mitarbeiter",
        fifty_to_two_hundred_forty_nine_employees: "50–249 Mitarbeiter",
        two_hundred_fifty_or_more_employees: "250 oder mehr Mitarbeiter",
      },
      autocomplete: {
        create_error:
          "Beim Anlegen des Unternehmens ist ein Fehler aufgetreten",
        create_item: "%{item} anlegen",
        create_label: "Tippen Sie, um ein neues Unternehmen anzulegen",
      },
    },
    contacts: {
      name: "Kontakt |||| Kontakte",
      forcedCaseName: "Kontakt",
      field_categories: {
        background_info: "Hintergrund",
        identity: "Identität",
        misc: "Sonstiges",
        personal_info: "Persönliche Daten",
        position: "Position",
      },
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        last_seen: "Zuletzt gesehen",
        title: "Titel",
        company_id: "Unternehmen",
        email_jsonb: "E-Mail-Adressen",
        email: "E-Mail",
        phone_jsonb: "Telefonnummern",
        phone_number: "Telefonnummer",
        birthday: "Geburtstag",
        linkedin_url: "LinkedIn-URL",
        background: "Hintergrund (Bio, wie kennengelernt etc.)",
        has_newsletter: "Newsletter-Abonnent",
        sales_id: "Zuständig",
      },
      action: {
        add: "Kontakt hinzufügen",
        add_first: "Ersten Kontakt hinzufügen",
        create: "Kontakt anlegen",
        edit: "Kontakt bearbeiten",
        export_vcard: "Als vCard exportieren",
        new: "Neuer Kontakt",
        show: "Kontakt anzeigen",
      },
      background: {
        last_activity_on: "Letzte Aktivität am %{date}",
        added_on: "Hinzugefügt am %{date}",
        followed_by: "Betreut von %{name}",
        followed_by_you: "Von Ihnen betreut",
        status_none: "Keiner",
      },
      position_at: "%{title} bei",
      position_at_company: "%{title} bei %{company}",
      empty: {
        description: "Ihre Kontaktliste ist leer.",
        title: "Keine Kontakte gefunden",
      },
      import: {
        title: "Kontakte importieren",
      },
      inputs: {
        genders: {
          male: "Er/Ihm",
          female: "Sie/Ihr",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Geschäftlich",
          home: "Privat",
          mobile: "Mobil",
          other: "Sonstige",
        },
      },
      list: {
        error_loading: "Fehler beim Laden der Kontakte",
      },
      bulk_tag: {
        action: "Taggen",
        back: "Zurück zu den Tags",
        create_description:
          "Einen neuen Tag anlegen und den ausgewählten Kontakten zuweisen.",
        description:
          "Einen vorhandenen Tag wählen oder einen neuen für die ausgewählten Kontakte anlegen.",
        empty:
          "Noch keine Tags. Leg einen an, um die ausgewählten Kontakte zu taggen.",
        error: "Tag konnte den Kontakten nicht zugewiesen werden",
        noop: "Die ausgewählten Kontakte haben diesen Tag schon",
        success:
          "Tag %{smart_count} Kontakt zugewiesen |||| Tag %{smart_count} Kontakten zugewiesen",
        title: "Tag zu Kontakten hinzufügen",
      },
      merge: {
        action: "Mit anderem Kontakt zusammenführen",
        confirm: "Kontakte zusammenführen",
        current_contact: "Aktueller Kontakt (wird gelöscht)",
        description: "Diesen Kontakt mit einem anderen zusammenführen.",
        error: "Zusammenführen fehlgeschlagen",
        merging: "Zusammenführen…",
        no_additional_data: "Keine zusätzlichen Daten zum Zusammenführen",
        select_target: "Bitte wählen Sie einen Kontakt zum Zusammenführen aus",
        success: "Kontakte erfolgreich zusammengeführt",
        target_contact: "Zielkontakt (wird behalten)",
        title: "Kontakt zusammenführen",
        warning_description:
          "Alle Daten werden auf den zweiten Kontakt übertragen. Diese Aktion kann nicht rückgängig gemacht werden.",
        warning_title: "Achtung: Unwiderrufliche Aktion",
        what_will_be_merged: "Folgende Daten werden zusammengeführt:",
      },
      filters: {
        before_last_month: "Vor letztem Monat",
        before_this_month: "Vor diesem Monat",
        before_this_week: "Vor dieser Woche",
        managed_by_me: "Von mir betreut",
        search: "Name, Unternehmen suchen…",
        this_week: "Diese Woche",
        today: "Heute",
        tags: "Tags",
        tasks: "Aufgaben",
      },
      hot: {
        empty_change_status:
          'Ändern Sie den Status eines Kontakts, indem Sie eine Notiz hinzufügen und auf „Optionen anzeigen" klicken.',
        empty_hint: 'Kontakte mit dem Status „Heiß" werden hier angezeigt.',
        title: "Heiße Kontakte",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Beschreibung",
        company_id: "Unternehmen",
        contact_ids: "Kontakte",
        category: "Kategorie",
        amount: "Budget",
        expected_closing_date: "Voraussichtliches Abschlussdatum",
        stage: "Phase",
      },
      action: {
        back_to_deal: "Zurück zum Deal",
        create: "Deal anlegen",
        new: "Neuer Deal",
      },
      field_categories: {
        misc: "Sonstiges",
      },
      filters: {
        only_mine: "Nur meine Deals",
      },
      archived: {
        action: "Archivieren",
        error: "Fehler: Deal nicht archiviert",
        list_title: "Archivierte Deals",
        success: "Deal archiviert",
        title: "Archivierter Deal",
        view: "Archivierte Deals anzeigen",
      },
      inputs: {
        linked_to: "Verknüpft mit",
      },
      unarchived: {
        action: "Zurück aufs Board",
        error: "Fehler: Deal nicht wiederhergestellt",
        success: "Deal wiederhergestellt",
      },
      updated: "Deal aktualisiert",
      empty: {
        before_create: "bevor Sie einen Deal anlegen.",
        description: "Ihre Deal-Liste ist leer.",
        title: "Keine Deals gefunden",
      },
      import: {
        title: "Deals importieren",
      },
      invalid_date: "Ungültiges Datum",
    },
    notes: {
      name: "Notiz |||| Notizen",
      forcedCaseName: "Notiz",
      fields: {
        status: "Status",
        date: "Datum",
        attachments: "Anhänge",
        contact_id: "Kontakt",
        deal_id: "Deal",
      },
      action: {
        add: "Notiz hinzufügen",
        add_first: "Erste Notiz hinzufügen",
        delete: "Notiz löschen",
        edit: "Notiz bearbeiten",
        update: "Notiz aktualisieren",
        add_this: "Diese Notiz hinzufügen",
      },
      sheet: {
        create: "Notiz erstellen",
        create_for: "Notiz für %{name} erstellen",
        edit: "Notiz bearbeiten",
        edit_for: "Notiz für %{name} bearbeiten",
      },
      deleted: "Notiz gelöscht",
      empty: "Noch keine Notizen",
      author_added: "%{name} hat eine Notiz hinzugefügt",
      you_added: "Sie haben eine Notiz hinzugefügt",
      me: "Ich",
      list: {
        error_loading: "Fehler beim Laden der Notizen",
      },
      note_for_contact: "Notiz für %{name}",
      stepper: {
        hint: "Öffnen Sie eine Kontaktseite und fügen Sie eine Notiz hinzu",
      },
      added: "Notiz hinzugefügt",
      inputs: {
        add_note: "Notiz hinzufügen",
        options_hint: "(Dateien anhängen oder Details ändern)",
        show_options: "Optionen anzeigen",
      },
      actions: {
        attach_document: "Dokument anhängen",
      },
      validation: {
        note_or_attachment_required: "Notiz oder Anhang erforderlich",
      },
    },
    sales: {
      name: "Mitglied |||| Mitglieder",
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        email: "E-Mail",
        phone: "Telefon",
        birthday: "Geburtstag",
        address: "Adresse",
        tags: "Ausschüsse",
        fraktion: "Fraktion",
        secondary_email: "Weitere E-Mail",
        secondary_emails: "Weitere E-Mail-Adressen",
        administrator: "Admin",
        superadmin: "Superadmin",
        disabled: "Deaktiviert",
        bv_mode: "BV-Zugang (MCP)",
        bv_list: "Gremien",
      },
      bv: {
        none: "Kein Zugang",
        list: "Ausgewählte Gremien",
        admin: "Voller Zugang",
        list_help:
          "Ein Gremium pro Zeile, ein Teil des Namens genügt (z. B. Kultur).",
      },
      create: {
        error: "Beim Anlegen des Mitglieds ist ein Fehler aufgetreten.",
        success:
          "Mitglied angelegt. Eine E-Mail zum Setzen des Passworts wird in Kürze versendet.",
        title: "Neues Mitglied anlegen",
      },
      edit: {
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        record_not_found: "Datensatz nicht gefunden",
        success: "Mitglied erfolgreich aktualisiert",
        title: "%{name} bearbeiten",
      },
      action: {
        new: "Neues Mitglied",
      },
    },
    tasks: {
      name: "Aufgabe |||| Aufgaben",
      forcedCaseName: "Aufgabe",
      fields: {
        text: "Beschreibung",
        due_date: "Fällig am",
        type: "Typ",
        contact_id: "Kontakt",
        due_short: "fällig",
      },
      action: {
        add: "Aufgabe hinzufügen",
        create: "Aufgabe erstellen",
        edit: "Aufgabe bearbeiten",
      },
      actions: {
        postpone_next_week: "Auf nächste Woche verschieben",
        postpone_tomorrow: "Auf morgen verschieben",
        title: "Aufgabenaktionen",
      },
      added: "Aufgabe hinzugefügt",
      deleted: "Aufgabe erfolgreich gelöscht",
      dialog: {
        create: "Aufgabe erstellen",
        create_for: "Aufgabe für %{name} erstellen",
      },
      sheet: {
        edit: "Aufgabe bearbeiten",
        edit_for: "Aufgabe für %{name} bearbeiten",
      },
      empty: "Noch keine Aufgaben",
      empty_list_hint:
        "Aufgaben, die Ihren Kontakten zugewiesen wurden, erscheinen hier.",
      filters: {
        later: "Später",
        overdue: "Überfällig",
        this_week: "Diese Woche",
        today: "Heute",
        tomorrow: "Morgen",
        with_pending: "Mit offenen Aufgaben",
      },
      regarding_contact: "(Betr.: %{name})",
      updated: "Aufgabe aktualisiert",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Tag hinzufügen",
        create: "Neuen Tag erstellen",
      },
      dialog: {
        color: "Farbe",
        create_title: "Neuen Tag erstellen",
        edit_title: "Tag bearbeiten",
        name_label: "Tag-Name",
        name_placeholder: "Tag-Namen eingeben",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Passwort zurücksetzen",
    },
    auth: {
      first_name: "Vorname",
      last_name: "Nachname",
      confirm_password: "Passwort bestätigen",
      confirmation_required:
        "Bitte folgen Sie dem Link in der E-Mail, die wir Ihnen gerade gesendet haben, um Ihr Konto zu bestätigen.",
      recovery_email_sent:
        "Falls Sie ein registrierter Benutzer sind, erhalten Sie in Kürze eine E-Mail zur Passwort-Wiederherstellung.",
      sign_in_failed: "Anmeldung fehlgeschlagen.",
      sign_in_google_workspace: "Mit Google Workspace anmelden",
      signup: {
        create_account: "Konto erstellen",
        create_first_user:
          "Erstellen Sie das erste Benutzerkonto, um die Einrichtung abzuschließen.",
        creating: "Wird erstellt…",
        initial_user_created: "Erster Benutzer erfolgreich angelegt",
      },
      welcome_title: "Willkommen im Volt Hamburg Hub",
    },
    common: {
      account_manager: "Zuständig",
      activity: "Aktivität",
      added: "hinzugefügt",
      details: "Details",
      last_activity_with_date: "letzte Aktivität %{date}",
      load_more: "Mehr laden",
      misc: "Sonstiges",
      past: "Vergangen",
      read_more: "Mehr lesen",
      retry: "Erneut versuchen",
      show_less: "Weniger anzeigen",
      copied: "Kopiert!",
      copy: "Kopieren",
      loading: "Wird geladen…",
      me: "Ich",
      task_count: "%{smart_count} Aufgabe |||| %{smart_count} Aufgaben",
    },
    changelog: {
      title: "Änderungen",
    },
    attendance: {
      menu: "Anwesenheit",
    },
    nav: {
      general: "Allgemein",
    },
    funding_list: {
      menu: "Quartiersfonds",
    },
    activity: {
      added_company: "%{name} hat Unternehmen hinzugefügt",
      you_added_company: "Sie haben Unternehmen hinzugefügt",
      added_contact: "%{name} hat hinzugefügt",
      you_added_contact: "Sie haben hinzugefügt",
      added_note: "%{name} hat eine Notiz hinzugefügt über",
      you_added_note: "Sie haben eine Notiz hinzugefügt über",
      added_note_about_deal: "%{name} hat eine Notiz zum Deal hinzugefügt",
      you_added_note_about_deal: "Sie haben eine Notiz zum Deal hinzugefügt",
      added_deal: "%{name} hat Deal hinzugefügt",
      you_added_deal: "Sie haben Deal hinzugefügt",
      at_company: "bei",
      to: "zu",
      load_more: "Mehr Aktivitäten laden",
    },
    dashboard: {
      deals_chart: "Erwartete Deal-Umsätze",
      deals_pipeline: "Deal-Pipeline",
      latest_activity: "Letzte Aktivität",
      latest_activity_error: "Fehler beim Laden der letzten Aktivität",
      latest_notes: "Meine letzten Notizen",
      latest_notes_added_ago: "hinzugefügt %{timeAgo}",
      stepper: {
        install: "Atomic CRM einrichten",
        progress: "%{step}/3 erledigt",
        whats_next: "Wie geht es weiter?",
      },
      upcoming_tasks: "Anstehende Aufgaben",
    },
    data_import: {
      button: "CSV importieren",
      complete:
        "Import abgeschlossen. %{importCount} Datensätze importiert, %{errorCount} Fehler",
      csv_file: "CSV-Datei",
      error:
        "Import fehlgeschlagen. Bitte stellen Sie sicher, dass die Datei ein gültiges CSV-Format hat.",
      progress:
        "%{importCount} / %{rowCount} Datensätze importiert, %{errorCount} Fehler.",
      remaining_time: "Geschätzte Restzeit:",
      resource: "Art der Daten",
      running: "Der Import läuft. Bitte schließen Sie diesen Tab nicht.",
      sample_download: "CSV-Vorlage herunterladen",
      sample_hint:
        "Hier ist eine CSV-Vorlage, die Sie als Muster verwenden können",
      start: "Import starten",
      stop: "Import abbrechen",
      title: "Daten importieren",
    },
    header: {
      import_data: "Daten importieren",
    },
    image_editor: {
      change: "Ändern",
      drop_hint: "Datei hierher ziehen oder klicken, um eine auszuwählen.",
      editable_content: "Bearbeitbarer Inhalt",
      file_too_large:
        "Das Bild ist größer als %{max} MB. Bitte wählen Sie ein kleineres.",
      file_invalid: "Bitte wählen Sie ein JPEG-, PNG- oder WebP-Bild.",
      processing_failed:
        "Das Bild ließ sich nicht verarbeiten. Bitte versuchen Sie ein anderes.",
      title: "Bild hochladen und zuschneiden",
      update_image: "Bild aktualisieren",
    },
    import: {
      action: {
        download_error_report: "Fehlerbericht herunterladen",
        import: "Importieren",
        import_another: "Weitere Datei importieren",
      },
      error: {
        unable: "Diese Datei kann nicht importiert werden.",
      },
      idle: {
        description_1:
          "Sie können Mitglieder, Unternehmen, Kontakte, Notizen und Aufgaben importieren.",
        description_2:
          "Die Daten müssen in einer JSON-Datei vorliegen, die folgendem Muster entspricht:",
      },
      status: {
        all_success: "Alle Datensätze wurden erfolgreich importiert.",
        complete: "Import abgeschlossen.",
        failed: "Fehlgeschlagen",
        imported: "Importiert",
        in_progress:
          "Import läuft. Bitte navigieren Sie nicht von dieser Seite weg.",
        some_failed: "Einige Datensätze konnten nicht importiert werden.",
        table_caption: "Import-Status",
      },
      title: "Daten importieren",
    },
    settings: {
      about: "Über",
      companies: {
        sectors: "Branchen",
      },
      dark_mode_logo: "Logo (Dunkelmodus)",
      deals: {
        categories: "Kategorien",
        currency: "Währung",
        pipeline_help:
          "Wählen Sie, welche Deal-Phasen als Pipeline-Deals zählen sollen.",
        pipeline_statuses: "Pipeline-Status",
        stages: "Phasen",
      },
      light_mode_logo: "Logo (Hellmodus)",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Auf Standardwerte zurücksetzen",
      save_error: "Konfiguration konnte nicht gespeichert werden",
      saved: "Konfiguration erfolgreich gespeichert",
      saving: "Wird gespeichert…",
      tasks: {
        types: "Typen",
      },
      preferences: "Einstellungen",
      title: "Einstellungen",
      app_title: "App-Titel",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Doppelte %{display_name}: %{items}",
        in_use:
          "%{display_name}, die noch von Deals verwendet werden, können nicht entfernt werden: %{items}",
        validating: "Wird überprüft…",
        entities: {
          categories: "Kategorien",
          stages: "Phasen",
        },
      },
    },
    theme: {
      dark: "Dunkel",
      label: "Darstellung",
      light: "Hell",
      system: "System",
    },
    language: "Sprache",
    navigation: {
      account: "Konto",
      label: "CRM-Navigation",
    },
    profile: {
      add_secondary_email: "E-Mail hinzufügen",
      email_taken: "%{email} wird schon von einem anderen Mitglied verwendet",
      no_secondary_emails: "Keine",
      secondary_email_invalid: "%{email} ist keine gültige E-Mail-Adresse",
      secondary_email_is_primary: "%{email} ist schon Ihre Haupt-Adresse",
      secondary_email_taken:
        "%{email} wird schon von einem anderen Mitglied verwendet",
      too_many_secondary_emails: "Höchstens 10 weitere E-Mail-Adressen möglich",
      secondary_emails_help:
        "Weitere Adressen, von denen Sie Mails senden. Leer lassen entfernt die Adresse.",
      inbound: {
        description:
          "Sie können E-Mails an die Eingangsadresse Ihres Servers senden, z. B. indem Sie sie in das %{field}-Feld einfügen. Atomic CRM verarbeitet die E-Mails und fügt Notizen zu den entsprechenden Kontakten hinzu.",
        title: "Eingehende E-Mails",
      },
      google: {
        title: "Verbindungen · Google",
        description:
          "Verbindet Ihr eigenes Google-Konto mit dem Volt-Assistenten: Mails lesen und Entwürfe anlegen (kein Senden), Kalender und Drive.",
        status_connected: "Verbunden als %{email}",
        status_disconnected: "Nicht verbunden",
        connect: "Verbinden",
        reconnect: "Neu verbinden",
        disconnect: "Trennen",
        missing_scopes: "Es fehlen Berechtigungen. Bitte neu verbinden.",
        confirm_title: "Google trennen?",
        confirm_content:
          "Der Volt-Assistent hat danach keinen Zugriff mehr auf Ihre Mails, Ihren Kalender und Ihr Drive. Die Freigabe wird auch bei Google widerrufen.",
        result_connected: "Google ist verbunden.",
        result_error: "Die Verbindung mit Google ist fehlgeschlagen.",
        result_foreign:
          "Diese Google-Freigabe wurde von einem anderen Konto gestartet und nicht gespeichert. Bitte verbinden Sie hier Ihr eigenes Konto.",
        result_expired:
          "Der Google-Link ist abgelaufen oder ungültig. Bitte verbinden Sie erneut.",
        disconnected: "Google ist getrennt.",
        disconnect_error: "Trennen ist fehlgeschlagen. Bitte erneut versuchen.",
        load_error: "Der Verbindungsstatus ist gerade nicht abrufbar.",
      },
      mcp: {
        title: "MCP-Server",
        description:
          "Mit dieser URL verbinden Sie Ihren KI-Assistenten über das Model Context Protocol (MCP) mit den CRM-Daten.",
      },
      password: {
        change: "Passwort ändern",
      },
      password_reset_sent:
        "Eine E-Mail zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet",
      record_not_found: "Datensatz nicht gefunden",
      title: "Profil",
      updated: "Ihr Profil wurde aktualisiert",
      update_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut",
    },
    validation: {
      invalid_url: "Muss eine gültige URL sein",
      invalid_linkedin_url: "URL muss von linkedin.com stammen",
    },
  },
} satisfies CrmMessages;
